import { renderInlineMarkdown } from "../../../../services/markdown.js";

export default class QuizResults {
  render(message) {
    const results = message.data?.results || {};
    const row = document.createElement("div");
    row.className = "ws-bot-row ws-quiz-results-row";
    if (message.isFirstResponse) row.classList.add("ws-fr");

    const avatar = document.createElement("span");
    avatar.className = "ws-avatar ws-bot-avatar ws-quiz-avatar-spacer";
    avatar.setAttribute("aria-hidden", "true");

    const wrap = document.createElement("div");
    wrap.className = "ws-quiz-results-content";

    const card = document.createElement("div");
    card.className = "ws-card-quiz-result";

    const imgWrap = document.createElement("div");
    imgWrap.className = "ws-card-quiz-wine-image";
    if (results.image_link) {
      const img = document.createElement("img");
      img.src = results.image_link;
      img.alt = "";
      imgWrap.appendChild(img);
    }

    const body = document.createElement("div");
    body.className = "ws-card-quiz-result-body";

    const title = document.createElement("p");
    title.className = "ws-card-quiz-result-title";
    title.textContent = results.title || "";

    const desc = document.createElement("div");
    desc.className = "ws-card-quiz-result-desc";
    desc.innerHTML = renderInlineMarkdown(results.description || "");

    body.appendChild(title);
    body.appendChild(desc);
    card.appendChild(imgWrap);
    card.appendChild(body);
    wrap.appendChild(card);

    row.appendChild(avatar);
    row.appendChild(wrap);
    return row;
  }
}
